import React, { Fragment } from 'react'
import { Segment, Button, Loader, Divider } from 'semantic-ui-react'
import SvgIcon from './svg-icon'
import { getAuthor } from './utils'

const StoryStartScreen = (props) => {
  const {
    story,
    onClose
  } = props

  const getLicense = (kind) => {
    if (kind.indexOf('/by-nc/') !== -1) {
      return 'BY-NC'
    } else if (kind.indexOf('/zero/') !== -1) {
      return 'CC'
    } else if (kind.indexOf('/by/') !== -1 || kind === 'creative-commons-attribution') {
      return 'BY'
    } else if (kind === 'public-domain') {
      return 'public'
    } else {
      return '???'
    }
  }

  const assetsArray = Object.entries(story.assets).map(([_, s]) => s)
  const assets = assetsArray.filter(({info}) => info && info.attribution).map(({icon, info}) => ({
    icon,
    attribution: info.attribution,
    license: getLicense(info.license)
  }))

  const soundsArray = Object.entries(story.sounds).map(([_, s]) => s)
  const sounds = soundsArray.filter(({sound}) => sound.username && sound.name && sound.license).map(({sound}) => ({
    name: sound.name,
    username: sound.username,
    license: getLicense(sound.license)
  }))

  return (
    <Segment inverted padded='very' style={{ width: 350}}>
      <Button basic inverted circular icon='arrow left' onClick={onClose} style={{ position: 'absolute', top: 10, left: 10 }} />
      { story ? (
        <Fragment>
          <div style={{ fontStyle: 'italic' }}>Moiki présente</div>
          <h2 style={{ marginBottom: '0.3em' }}>{ story.meta.name }</h2>
          <div style={{ fontStyle: 'italic', color: '#9e9a9a', marginBottom: '1em' }}>Une histoire de { getAuthor(story.meta) }</div>
          <Divider style={{ marginTop: '2.5em' }} inverted horizontal>Crédits</Divider>
          <div style={{ minHeight: 130, maxHeight: 192, overflowY: 'auto' }}>
            <h4>Image de couverture</h4>
            { (story.meta.imageInfo && story.meta.imageInfo.user) ? (
              <div>
                by <a href={story.meta.imageInfo.hotlink} target="_blank" rel="noreferrer noopener">{story.meta.imageInfo.user}</a>
                <div style={{ fontStyle: 'italic', color: '#9e9a9a' }}>(<a target="_blank" rel="noreferrer noopener" href="https://unsplash.com/?utm_source=Moiki&utm_medium=moiki.fr">Unsplash</a>)</div>
              </div>
            ) : (
              <div style={{ fontStyle: 'italic', color: '#9e9a9a' }}><a target="_blank" rel="noreferrer noopener" href="https://unsplash.com/?utm_source=Moiki&utm_medium=moiki.fr">Unsplash</a></div>
            )}
            { assetsArray && assetsArray.length > 0 && (
              <div className='credits-assets-list'>
                <Divider />
                <h4 style={{ marginTop: '1em' }}>Icônes</h4>
                <div style={{ fontStyle: 'italic', marginBottom: '1em', color: '#9e9a9a' }}>Toutes les icônes proviennent de <a target="_blank" rel="noreferrer noopener" href="https://thenounproject.com/">The Noun Project</a></div>
                { assets && assets.map(({icon, attribution, license}, idx) => (
                  <Fragment key={ 'icon-credit-' + idx }>
                    { idx > 0 && (<div>---</div>)}
                    <SvgIcon
                      icon={icon}
                      style={{ fill: '#fff', stroke: '#fff', margin: 0, paddingBottom: '.5em', paddingTop: '1em', display: 'inline-block' }}
                    />
                    <div style={{ overflowWrap: 'break-word' }}>{attribution}</div>
                    <div style={{ fontSize: '.7em' }}>license: {license}</div>
                  </Fragment>
                ))}
              </div>
            )}
            { soundsArray && soundsArray.length > 0 && (
              <Fragment>
                <Divider />
                <h4 style={{ marginTop: '1em' }}>Sons</h4>
                <div style={{ fontStyle: 'italic', marginBottom: '1em', color: '#9e9a9a' }}>Tous les sons proviennent de <a target="_blank" rel="noreferrer noopener" href="https://freesound.org/">Freesound</a></div>
                { sounds && sounds.map(({name, username, license}, idx) => (
                  <Fragment key={ 'sound-credit-' + idx }>
                    { idx > 0 && (<div>---</div>)}
                    <div><em style={{ overflowWrap: 'break-word' }}>{name}</em> by {username}</div>
                    <div style={{ fontSize: '.7em' }}>license: {license}</div>
                  </Fragment>
                ))}
              </Fragment>
            )}
          </div>
         </Fragment>
      ) : (
        <Loader active={true} />
      )}
    </Segment>
  )
}

export default StoryStartScreen